import Button from '@mui/joy/Button';
import { fauceteer } from '../Config/configUSDC';

export const FaucetButton = ({USDCaddress}) => {
    async function useFaucet() {
        await fauceteer.drip(USDCaddress);
    }

    return(
        <Button size="sm" onClick={useFaucet}>USDC faucet</Button>
    )
}